import { DoctorService } from '@/services/doctor.service.js';
import { AdminsService } from '../../services/admins.service.js';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      alert: {
        show: false,
        message: ''
      },
      doctors: [],
      selectedDoctor: null,
      showDialog: false,
      categories: ['Doctor', 'Package', 'Patient', 'Pharmacy'],
      selectedType: 'Doctor',
      selectedIssue: 'Prescribing issue',
      notes: '',
      issues: {
        Doctor: ['Prescribing issue', 'Unresponsive to Patient', 'Unresponsive to PS', 'Verification Error'],
        Package: ['Shipping Delay - Pharmacy', 'Shipping Delay - Carrier', 'Product Damaged', 'Product Never Arrived'],
        Patient: ['Reported Fraudulent Charges', 'Aggressive Behavior', 'Risk of Offboarding'],
        Pharmacy: ['Incorrect Medication Sent', 'Medication Not Sent', 'Shipping Delay']
      },
      buttonDisabledOverride: false
    };
  },
  computed: {
    buttonDisabled() {
      if (this.buttonDisabledOverride) {
        return true;
      }
      if (this.selectedDoctor === null || this.notes.trim() === '') {
        return true;
      }
    },
    doctorOptions() {
      return this.doctors.map(doctor => ({
        code: doctor.id,
        label: `Dr. ${doctor.firstname} ${doctor.lastname}`
      }));
    }
  },
  watch: {
    async showDialog() {
      this.selectedType = 'Doctor';
      this.notes = '';
      this.alert.show = false;
      this.buttonDisabledOverride = false;
      const {
        data
      } = await DoctorService.getAllDoctors(true);
      this.doctors = data;
      this.selectedDoctor = this.rowData.doctorid;
    },
    selectedType(type) {
      this.selectedIssue = this.issues[type][0];
    }
  },
  methods: {
    async submitReport() {
      if (!this.notes) {
        this.alert.message = 'Please fill in all the fields.';
        this.alert.show = true;
        return;
      }
      const body = {
        note: this.notes,
        type: this.selectedType,
        issue: this.selectedIssue,
        doctorid: this.selectedDoctor
      };
      try {
        this.buttonDisabledOverride = true;
        const {
          data
        } = await AdminsService.reportIssue(this.rowData.id, body);
        if (data) {
          this.showDialog = false;
        }
      } catch (err) {
        this.alert.message = err;
        this.alert.show = true;
      } finally {
        this.buttonDisabledOverride = false;
      }
    }
  }
};